import { Image } from "antd";
import { Scrollbars } from "react-custom-scrollbars-2";
import styles from "./index.module.less";
const BMPS = [
  "0001surface.BMP",
  "0002surface.BMP",
  "0003surface.BMP",
  "0004surface.BMP",
  "0005surface.BMP",
  "0006surface.BMP",
  "0007surface.BMP",
  "0008surface.BMP",
  "0009surface.BMP",
  "0010surface.BMP",
  "0011surface.BMP",
  "0012surface reference.BMP",
  "0013bottom of surface.BMP",
  "0015bottom of surface.BMP",
  "0016bottom of surface.BMP",
  "0017bottom of surface.BMP",
  "0018bottom of surface.BMP",
  "0019bottom of surface.BMP",
  "0020bottom of surfacereference.BMP",
  "0021_4th layer.BMP",
  "0022_4th layer.BMP",
  "0023_4th layer.BMP",
  "0024_4th layer.BMP",
  "0025_4th layer.BMP",
  "0026_4th layer.BMP",
  "0027_4th layer.BMP",
  "0028_4th layer.BMP",
  "0029_4th layer reference.BMP",
  "0030_40 cm.BMP",
  "0031_40 cm.BMP",
  "0033_40 cm.BMP",
  "0034_40 cm.BMP",
  "0035_40 cm.BMP",
  "0037_40 cm.BMP",
  "0038_40 cm.BMP",
  "0039_40 cm.BMP",
  "0040_40 cm reference.BMP",
  "0041_30 cm.BMP",
  "0042_30 cm.BMP",
  "0043_30 cm.BMP",
  "0044_30 cm.BMP",
  "0046_30 cm.BMP",
  "0048_30 cm.BMP",
  "0049_30 cm reference.BMP",
  "0050_20 cm.BMP",
  "0052_20 cm.BMP",
  "0053_20 cm.BMP",
  "0054_20 cm.BMP",
  "0055_20 cm.BMP",
  "0056_20 cm.BMP",
  "0057_20 cm.BMP",
  "0058_20 cm reference.BMP",
  "0059_15 cm.BMP",
  "0060_15 cm.BMP",
  "0061_15 cm.BMP",
  "0062_15 cm.BMP",
  "0063_15 cm.BMP",
  "0064_15 cm.BMP",
  "0065_15 cm reference.BMP",
  "0066_8 cm.BMP",
  "0067_8 cm.BMP",
  "0068_8 cm.BMP",
  "0069_8 cm.BMP",
  "0070_8 cm.BMP",
  "0071_8 cm.BMP",
  "0072_8 cm.BMP",
  "0073_8 cm.BMP",
  "0074_8 cm reference.BMP",
  "0075_1st.BMP",
  "0076_1st.BMP",
  "0077_1st.BMP",
  "0078_1st.BMP",
  "0079_1st.BMP",
  "0080_1st.BMP",
  "0081_1st reference.BMP",
];
function BMPAlbum() {
  const items = BMPS.map((b) => (
    <div className="album-item">
      <div className="album-bmp">
        <Image
          width={300}
          src={`http://arcticroute.tpdc.ac.cn/geojson/bmp/${b}`}
        />
      </div>
      <div className="album-name">{b}</div>
    </div>
  ));
  return (
    <div className={styles.albumContainer}>
      <Scrollbars>
        <div className="album-list">{items}</div>
      </Scrollbars>
    </div>
  );
}

export default BMPAlbum;
